import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const slides = [
    {
        id: 1,
        image: 'https://images.unsplash.com/photo-1523170335258-f5ed11844a49?q=80&w=2080&auto=format&fit=crop',
        title: 'Timeless Elegance',
        subtitle: 'Discover the new Royal Collection',
    },
    {
        id: 2,
        image: 'https://images.unsplash.com/photo-1524592094714-0f0654e20314?q=80&w=1999&auto=format&fit=crop',
        title: 'Precision Mastery',
        subtitle: 'Engineering meets Artistry',
    },
    {
        id: 3,
        image: 'https://images.unsplash.com/photo-1522312346375-d1a52e2b99b3?q=80&w=1988&auto=format&fit=crop',
        title: 'Modern Luxury',
        subtitle: 'Redefining sophistication',
    },
];

const Hero = () => {
    return (
        <section className="relative h-screen w-full overflow-hidden">
            <Swiper
                modules={[Autoplay, EffectFade, Navigation, Pagination]}
                effect="fade"
                speed={1000}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                pagination={{ clickable: true }}
                className="h-full w-full"
            >
                {slides.map((slide) => (
                    <SwiperSlide key={slide.id}>
                        <div className="relative h-full w-full">
                            {/* Background Image with Overlay */}
                            <div
                                className="absolute inset-0 bg-cover bg-center transition-transform duration-[10000ms] hover:scale-105"
                                style={{ backgroundImage: `url(${slide.image})` }}
                            >
                                <div className="absolute inset-0 bg-black/20" />
                            </div>

                            {/* Content */}
                            <div className="relative h-full container mx-auto px-4 md:px-8 flex flex-col justify-center items-start z-10">
                                <h2 className="text-luxury-gold text-lg md:text-xl uppercase tracking-[0.2em] mb-4 animate-fade-in-up">
                                    {slide.subtitle}
                                </h2>
                                <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif font-bold text-white mb-8 leading-tight max-w-4xl drop-shadow-lg">
                                    {slide.title}
                                </h1>
                                <button className="btn-primary">
                                    Explore Collection
                                </button>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

export default Hero;
